import { I18n } from "@assets/strings";
import React, { useEffect } from "react";
import styled from "styled-components";
import { usePrivacyValidated } from "@domain/privacy/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { PrivacyEditor } from "./privacyEditor";

interface PrivacyModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: (validated: boolean) => void;
}
export const PrivacyModal: React.FC<PrivacyModalProps> = ({ close, children, ...htmlProps }) => {
	const privacyValidated = usePrivacyValidated();

	useEffect(() => {
		if (privacyValidated) {
			setTimeout(() => {
				close(true);
			}, 200);
		}
	}, [privacyValidated]);

	return (
		<Container {...htmlProps} close={() => close(false)} title={I18n.t("auth.cgu.modal.title")}>
			<OneWayPrivacyEditor disabled={privacyValidated} />
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(25)};
	align-items: center;
	text-align: center;
`;

const OneWayPrivacyEditor = styled(PrivacyEditor)<{ disabled: boolean }>`
	${({ disabled }) => disabled && "pointer-events: none"};
`;
